export default "__VITE_ASSET__BThkA6n4__"